module.exports = __webpack_public_path__ + "img/water-droplet-new.db528cef.jpg";